import "core-js/modules/es.array.push.js";
import planModal from './planModal.vue';
import { auditScheduleStatus } from './request';
export default {
  components: {
    planModal
  },
  props: {
    planList: {
      type: Array,
      default: [],
      required: true
    }
  },
  data() {
    return {
      activeIndex: undefined,
      addVisible: false,
      isEdit: [],
      showList: this.planList
    };
  },
  watch: {
    planList: {
      handler(newV) {
        console.log(this.$props.planList, this.showList, newV);
        this.showList = newV;
      },
      deep: true
    }
  },
  mounted() {
    // window.addEventListener('click', this.onOperation);
  },
  beforeDestroy() {
    //   解绑监听click
    // window.removeEventListener('click', this.onOperation);
  },
  methods: {
    // onOperation(e, item, index) {
    //   if (!this.$el.contains(e.target)) {
    //     this.activeIndex = undefined;
    //   } else {
    //     this.activeIndex = index + 1;
    //   }
    // },
    openEditPlan(state) {
      this.isEdit.splice(0, this.isEdit.length);
      this.addVisible = true;
      if (state) {
        this.isEdit.push(state.id);
        this.isEdit.push(state.iconName);
        this.isEdit.push(state.name);
      }
    },
    savePlan(isEdit, data) {
      this.$message.success(this.$t('保存成功'));
      this.$emit('save', isEdit, data);
    },
    async deletePlan(id, index) {
      await auditScheduleStatus({
        id
      });
      this.$message.success(this.$t('删除成功'));
      this.$emit('update', index);
    },
    closeVisible() {
      this.addVisible = false;
      this.activeIndex = undefined;
    }
  }
};